import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Project from './Project';

const CheckAlsoProject = ({ data }) => {
  const { title, author, project_pic, excerpt, slug } = data;
  return <Project title={title} author={author} pic={project_pic} excerpt={excerpt} slug={slug} />;
};

CheckAlsoProject.propTypes = {
  title: PropTypes.string,
  author: PropTypes.string,
  project_pic: PropTypes.string,
  excerpt: PropTypes.string,
  slug: PropTypes.string
};

export default withRouter(CheckAlsoProject);
